function Header(props) {
  return null;
}

export default Header;
